import { render } from "./VehicleTypes.vue?vue&type=template&id=701e7fc8"
import script from "./VehicleTypes.vue?vue&type=script&lang=ts"
export * from "./VehicleTypes.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QInput});
